import React from 'react';
import type { TypographyProps } from '@makemydeal/dr-ui-bricks-types';
import { StyledTypography } from './typography.style';
import { VARIANT_MAP } from './constants';

const Typography: React.FC<TypographyProps> = ({ variant = 'body1', color, noWrap, gutterBottom, children, ...rest }) => {
    const Component = VARIANT_MAP[variant];

    return (
        <StyledTypography as={Component} variant={variant} color={color} noWrap={noWrap} gutterBottom={gutterBottom} {...rest}>
            {children}
        </StyledTypography>
    );
};

export default Typography;
